export function setBusinessServerListNameFilter(filter: string): BaseTockAction {
  return {
    type: 'SET_BUSINESS_SERVER_LIST_NAME_FILTER',
    payload: filter,
    context: {
      shouldTrack: true,
      keyToTrack: 'payload',
    },
  };
}

export function selectBusinessServer(businessServerId: number): BaseTockAction {
  return {
    type: 'SERVICE_SELECT_SERVER',
    payload: businessServerId,
  };
}

export function clearSelectedBusinessServer(): BaseTockAction {
  return {
    type: 'SERVICE_CLEAR_SERVER',
  };
}

export function startAssigningBusinessServer(businessServerId: number): BaseTockAction {
  return {
    type: 'START_ASSIGNING_BUSINESS_SERVER',
    payload: businessServerId,
  };
}

export function stopAssigningBusinessServer(): BaseTockAction {
  return {
    type: 'STOP_ASSIGNING_BUSINESS_SERVER',
    payload: null,
  };
}
